import * as React from "react";
import "./intro.scss";

interface IIntroProps {
  readonly extraClasses?: string;
  readonly title: string;
  readonly subtitle?: string;
}

class Intro extends React.Component<IIntroProps, {}> {
  public render() {
    return (
      <div className="intro">
        <h2 className="intro__title">{this.props.title}</h2>
        {this.props.subtitle && (
          <h3
            className="intro__subtitle"
            dangerouslySetInnerHTML={{ __html: this.props.subtitle }}
          />
        )}
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/components/intro/intro.tsx